module.exports = __webpack_public_path__ + "img/7W.f7bca375.png";